<template>
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms" style="margin-top: -40px">
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-flex lg12>
          <v-card pa-0>
            <v-toolbar>
              <v-toolbar-title>Mode Ujian Offline</v-toolbar-title>
              <v-spacer></v-spacer>
              <router-link :to="{path:'/tes/ujian'}">
                  <v-btn color="primary">
                    Ke Mode Ujian Online <v-icon right>arrow_forward</v-icon>
                  </v-btn>
                </router-link>
            </v-toolbar>
            <v-card-text>
              <div class="DashboardContainer"></div>
            </v-card-text>
            <v-toolbar card color="white">
              <v-text-field
                flat
                solo
                prepend-icon="search"
                placeholder="Type something"
                v-model="search"
                hide-details
                @click:prepend="showFilter = !showFilter"
                @input="searchTerm"
              ></v-text-field>                                            
              <v-btn color="success" @click="export2excel()" dark>
                <v-icon left>save</v-icon> export .xls
              </v-btn>                            
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text v-if="showFilter">
              <v-layout row wrap>
                <v-flex md6 xs12>
                  <v-btn-toggle class="mr-3" v-model="toggle_gender" multiple dark>
                    <v-btn small flat class="red white--text" :value="1">L</v-btn>
                    <v-btn small flat class="blue-grey white--text"  :value="2">P</v-btn>              
                  </v-btn-toggle>  
                  <v-btn-toggle v-model="toggle_tingkat" mandatory class="mr-3" dark>                
                    <v-btn round small v-for="(tingkat,i) in tingkats" :key="i" :value="tingkat.id" :color="getColor(tingkat.id)">{{tingkat.nama}}</v-btn>                
                  </v-btn-toggle>
                  <select v-model="gedung_id" class="subheading" style="border:1px solid #000; padding:1px 5px 3px;">
                    <option :value="null">-select ruangan-</option>
                    <template v-for="(gedung, n) in gedungs">
                      <option  :key="'group'+n" :value="gedung.id" class="optionGroup">{{gedung.nama}}</option>
                      <option  v-for="(ged, c) in gedung.childs" :key="'child'+n+''+c" :value="ged.id" class="optionChild"> &nbsp; {{gedung.nama}} <strong>{{ged.nama}}</strong></option>
                    </template>          
                  </select> 
                </v-flex>  
                <v-flex md2 xs12>
                  <v-text-field type="date" v-model="ujian_date" hide-details style="margin-top:-10px" clearable />
                </v-flex>      
              </v-layout>  
            </v-card-text>            
            <v-card-text class="pa-0 tabular">
              <v-progress-linear slot="progress" color="blue" class="pa-0 ma-0" indeterminate v-if="complex.loading"></v-progress-linear>  
              <div class="v-table__overflow" id="journal">
                <table class="tb-normal">
                  <thead>
                    <tr>
                      <th rowspan="2" v-for="(header,i) in complex.headers" :key="i">
                        {{header.text}}
                      </th>
                      <template v-for="(rapor, j) in ujians" >
                        <th :key="'r'+j" :colspan="2">
                          {{rapor.name}} <br/><small>[soal:{{rapor.childs.soal_jumlah}}, kkm:{{rapor.childs.soal_kkm}}]</small>
                        </th>                        
                      </template>
                      <th rowspan="2">RATA NILAI</th>                      
                    </tr>
                    <tr>
                      <template v-for="(rapor, j) in ujians">
                        <th :key="'.'+j">Benar</th>
                        <th :key="'r'+j">Nilai</th>                        
                      </template>                      
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, i) in complex.items" :key="i">
                      <td class="text-xs-center">{{ ((complex.pagination.currentPage-1)*20)+(i+1) }}</td>
                      <td>{{item.id}}</td>
                      <td style="min-width:190px">{{ item.nama }} ({{item.gender === 1?'L':'P'}})</td>
                      <td><template v-if="item.calonGedung">{{ item.calonGedung.number }}</template></td>  
                      <td  class="text-xs-center" v-if="tingkats.length > 0">
                        <template v-if="item.tingkat_id == 3">
                          {{ tingkats.find(x=>x.id===item.jurusan_id) ? tingkats.find(x=>x.id===item.jurusan_id).description : tingkats.find(x=>x.id===item.tingkat_id).description}}
                        </template>
                        <template v-else>
                          {{tingkats.find(x=>x.id===item.tingkat_id).description}}
                        </template>                    
                      </td>
                      <td><span>{{item.calonTest.ujian_date}}</span></td>
                      <td>
                        <template v-if="item.calonTest.ujian_hadir == 1">hadir</template>
                        <template v-else-if="item.calonTest.ujian_hadir == 0">tidak</template>
                        <template v-else>belum</template>                        
                      </td>
                      <template v-for="(ujian, j) in item.calonTest.ujians">
                        <td :key="j+'.'">
                          <input type="number" disabled @input="setData(item)" v-model="ujian.benar" style="padding:5px; max-width:55px" />
                        </td>
                        <td :key="j+'r'" style="border-color:#ccc!important" class="text-xs-center yellow lighten-4">
                          {{parseFloat(ujian.nilai=ujian.benar/ujian.childs.soal_jumlah*100).toFixed(2)}}
                        </td>                        
                      </template>
                      <td class="text-xs-center cyan lighten-4" style="border-color:#ccc!important">{{item.calonTest.ujian_nilai}}</td>                                        
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="pa-2">
                <v-pagination
                  v-model="complex.pagination.currentPage"
                  :length="complex.pagination.pageCount"
                  :total-visible="9"
                ></v-pagination>
              </div>
            </v-card-text>            
          </v-card>
        </v-flex>                           
        </v-layout>
        <v-dialog v-model="dialog_nilai" persistent max-width="290">        
          <v-card>
            <v-card-title class="headline">Reset Nilai <strong>{{nilai_fm.nama}}</strong></v-card-title>
            <v-card-text>
              <v-radio-group label="Pilih Matpel Yang akan direset :" v-model="nilai_matpelid" row>
                <v-radio label="All" value=""></v-radio>
                <template v-for="(rapor, j) in ujians" >
                  <v-radio :key="'r'+j" :label="rapor.name" :value="rapor.id"></v-radio>                     
                </template>                        
              </v-radio-group>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" flat @click="dialog_nilai = false">batal</v-btn>
              <v-btn color="blue darken-1" flat :loading="loading_reset_nilai" @click="ujianResetNilai(nilai_fm.id)">Submit</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog> 

        <v-dialog v-model="dialog_quetionnaire" persistent max-width="290">        
          <v-card>
            <v-card-title class="headline">Reset Jawaban Ujian <strong>{{nilai_fm.nama}}</strong></v-card-title>
            <v-card-text>
              <v-radio-group label="Pilih Matpel Yang akan direset :" v-model="quetionnaire_matpelid" row>
                <v-radio label="All" value=""></v-radio>
                <template v-for="(rapor, j) in ujians" >
                  <v-radio :key="'r'+j" :label="rapor.name" :value="rapor.id"></v-radio>                     
                </template>                        
              </v-radio-group>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" flat @click="dialog_quetionnaire = false">batal</v-btn>
              <v-btn color="blue darken-1" flat :loading="loading_reset_quetionnaire" @click="ujianResetQuetionnaire(quetionnaire_fm.id)">Submit</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>   
      </v-container>
    </div>
  </v-slide-y-transition>
</template>

<script>  
import { debounce } from 'lodash'
import Model from '@/apps/admin/models/Calon';   
const  model = new Model();
import Table2Excel from 'table2excel.js';  
import 'uppy/dist/uppy.min.css';
import Interface   from '@/util/interface';
import Toolbar from '../../components/app/Toolbar.vue';
const  api = Interface.biz4;

export default {
  components: { Toolbar },
    $_veeValidate: {
      validator: 'new'
    },    
    data: () => ({
        subtotal : 0,
        search   : '',
        loading  : true,
        toggle_tingkat : 2,
        toggle_gender : [],
        loading_refresh : false,
        pagination: {},
        complex  : {
            selected: [],
            headers: [
              { text: '#',   value: 'no'  },
              { text: 'ID',   value: 'id'  },
              { text: 'Nama', value: 'nama'},              
              { text: 'Nomor', value: 'calonGedung.number'},               
              { text: 'Tingkat', value: 'tingkat_id'},  
              { text: 'Tanggal', value: 'calonTest.ujian_date'},
              { text: 'Kehadiran', value: 'calonTest.ujian_hadir'},                            
            ],
            items: [],
            loading : false,
            options : {},
            pagination:{
              totalCount: null,
              pageCount: 0,
              currentPage: 1,
              perPage: 20
            },
        },
        loadingDownload : false,
        tingkats : [],
        status   : [],
        types    : [],
        data     : [],
        ujians   : [],
        gedungs  : [],
        gedung_id : null,
        ujian_date: null,
        showFilter : true,
        dialog_nilai : false,
        nilai_matpelid : null,
        nilai_fm : {},
        dialog_quetionnaire : false,
        quetionnaire_matpelid : null,
        quetionnaire_fm : {},
        loading_reset_nilai: false,
        loading_reset_quetionnaire: false,
    }),  
    watch:{
      toggle_tingkat(newArr){
        let tingkat = null, jurusan = null;
        let ar = newArr;
        if(ar <= 3){tingkat = ar} 
        else if(ar === 7){tingkat = ar}
        else{jurusan = ar}              
        this.init(this.complex.pagination.currentPage, this.toggle_gender, tingkat, jurusan);  
        this.getGedungs(newArr);      
      },
      toggle_gender(newArr){                
        this.init(this.complex.pagination.currentPage, newArr, this.filter.tingkat, this.filter.jurusan);        
      },
      'complex.pagination.currentPage'(newPage){        
        this.init(newPage, this.toggle_gender, this.filter.tingkat, this.filter.jurusan) 
      },
      'complex.options':{
        handler(){          
          this.init(this.complex.pagination.currentPage, this.toggle_gender, this.filter.tingkat, this.filter.jurusan)
        }, deep:true      
      },
      gedung_id(newId){
        this.init('', this.toggle_gender, this.filter.tingkat, this.filter.jurusan) 
      },
      ujian_date(newId){
        this.init('', this.toggle_gender, this.filter.tingkat, this.filter.jurusan) 
      }
    },
     computed:{
      filter(){        
        let tingkat = null, jurusan = null;
        let ar = this.toggle_tingkat;
        if(ar <= 3){tingkat = ar} 
        else if(ar === 7){tingkat = ar}
        else{jurusan = ar}
        return {tingkat: tingkat, jurusan:jurusan};
      }
    },
    mounted(){ 
      model.tingkats().then(data=>{this.tingkats = data});     
      this.init(1, '', this.toggle_tingkat);
      this.getGedungs(this.toggle_tingkat);  
      setTimeout(()=>{this.setUploads()}, 10);              
    },            
    methods: {      
        ujianRefresh(calon_id){
          this.loading_refresh = true;
          model.ujianRefresh({}, {calon_id:calon_id}).then(res=>{
            this.loading_refresh = false;
            console.log(res);
          })
        },

        ujianResetNilai(calon_id){
          this.loading_reset_nilai = true;
          model.ujianResetNilai({}, {calon_id:calon_id, matpelid:this.nilai_matpelid}).then(res=>{
            this.loading_reset_nilai = false;
            this.dialog_nilai = false;
            this.nilai_matpelid = null;
            this.nilai_fm = {};
            console.log(res);
          })
        },

        ujianResetQuetionnaire(calon_id){
          this.loading_reset_quetionnaire = true;
          model.ujianResetQuetionnaire({}, {calon_id:calon_id, matpelid:this.quetionnaire_matpelid}).then(res=>{
            this.loading_reset_quetionnaire = false;
            this.dialog_quetionnaire = false;
            this.quetionnaire_matpelid = null;
            this.quetionnaire_fm = {};
            console.log(res);
          })
        },

        format(tgl) { return this.$moment(tgl).format('DD-MM-YYYY')},
        
        getColor(tingkat){
          switch(tingkat){case 1:return 'red darken-2'; case 2: return 'indigo'; case 3:return 'blue-grey'; case 7:return 'light-green'; default:return 'blue-grey';}
        },
        
        getQuranWarna(status){
          switch(status){case 0:return 'yellow darken-2'; case 1: return 'green darken-2'; case -1:return 'red darken-2'; default:return 'blue-grey';}
        },
        
        getQuranStatus(status){
          switch(status){case 0:return 'mengulang'; case 1: return 'lulus'; case -1:return 'tidak lulus'; default:return '';}
        },

        getGedungs(tingkat){
          model.gedungs({tingkat:tingkat}).then(data=>{
            this.gedungs = data;
          });
        },
        
        searchTerm:debounce(function (newText) {         
          this.init(this.complex.pagination.currentPage, this.toggle_gender, this.filter.tingkat, this.filter.jurusan)                         
        }, 500),

        init(page = 1, gender='', tingkat='', jurusan_id=''){
          this.complex.loading = true
          model.settings({key:'ujian_'+this.toggle_tingkat}).then(data=>{            
            this.ujians = data.value;             
            
            let  sortby = this.complex.options.sortBy ? this.complex.options.descending ? 
                 '-'+this.complex.options.sortBy : this.complex.options.sortBy : 'id'; 

            const params = {
              perPage: 20,
              page: page,
              expand:'calonTest,calonGedung',
              'UserCalonSearch[nama]': this.search,
              'UserCalonSearch[gender]': gender,
              'UserCalonSearch[tingkat_id]': tingkat,
              'UserCalonSearch[jurusan_id]': jurusan_id,
              'UserCalonSearch[ujian_date]': this.ujian_date,
              gedung_id:this.gedung_id,
              nopagination:true              
            }
            this.complex.items = [];
            model.indexUjian(params).then(res => {                      
              res.data.forEach(item=>{
                let ujianEx = item.calonTest ? (item.calonTest.ujians?item.calonTest.ujians:[]):[];
                item.calonTest = item.calonTest ? item.calonTest : {};
                item.calonTest.ujians = []; 
                if(Array.isArray(this.ujians)){
                  this.ujians.forEach((ujian, i)=>{
                    let ujiantemp = ujianEx.find(x=>x.id==ujian.id);
                    item.calonTest.ujians.push({id:ujian.id,name:ujian.name,benar:(ujiantemp?ujiantemp.benar:null),nilai:(ujiantemp?ujiantemp.nilai:null) ,childs:ujian.childs});                                      
                  })
                }                
              });
              this.complex.items = res.data; 
              //this.complex.pagination.pageCount = res.pagination ? res.pagination.pageCount : 0;  
              this.complex.loading = false;
            });                                         
          });          
        },                                                                                        

        save(){
          model.saveUjian({data:this.data}).then((res)=>{
            if(res.status === 200){
              this.$swal({ type: 'success', title: 'Your work has been saved', showConfirmButton: false, timer: 1000});                              
              this.init(1, '', this.toggle_tingkat, this.toggle_tingkat);
            }
          });
        },

        export2excel(){
            if(this.complex.items.length !== 0){
                var filename = 'Ujian.';            
                filename    += this.$moment().format('DDMMYY.HHmm');
                new Table2Excel('#journal table').export(filename);
            } else {
                window.getApp.$emit('showSnackbar', {
                    show : true,
                    text : 'No Data Result',
                    color: 'orange'
                });
            }
        },
        
        setData(fm){
          let calonTest  = this.data.find(x=>x.calon_id === fm.id);
          fm.calonTest.ujian_benar = 0;
          let totalsoal = 0;
          fm.calonTest.ujians.forEach(ujian=>{
            ujian.benar = ujian.benar > ujian.childs.soal_jumlah ? ujian.childs.soal_jumlah : ujian.benar;
            fm.calonTest.ujian_benar += ujian.benar ? parseInt(ujian.benar) : 0; 
            totalsoal  += parseInt(ujian.childs.soal_jumlah);
          });         
          fm.calonTest.ujian_nilai = parseFloat(fm.calonTest.ujian_benar/totalsoal*100).toFixed(2);
          fm.calonTest.ujian_nilai = isNaN(fm.calonTest.ujian_nilai) ? null : fm.calonTest.ujian_nilai;
          fm.calonTest.ujian_hadir = parseInt(fm.calonTest.ujian_nilai)?1:0; 
          if(calonTest){
            calonTest.ujians = fm.calonTest.ujians;   
            calonTest.ujian_benar = fm.calonTest.ujian_benar;
            calonTest.ujian_nilai = fm.calonTest.ujian_nilai;            
            calonTest.ujian_hadir = fm.calonTest.ujian_hadir;            
          }else{            
            this.data.push({calon_id:fm.id, ujians:fm.calonTest.ujians, ujian_benar:fm.calonTest.ujian_benar, ujian_nilai:fm.calonTest.ujian_nilai, ujian_hadir:fm.calonTest.ujian_hadir});
          }
          console.log(this.data);
        },

        setUploads(){
          try{
            const Uppy = require('@uppy/core')
            const Dashboard = require('@uppy/dashboard')
            const XHRUpload = require('@uppy/xhr-upload')
            //const GoogleDrive = require('@uppy/google-drive')
            //const Dropbox = require('@uppy/dropbox')
            //const Instagram = require('@uppy/instagram')
            //const Webcam = require('@uppy/webcam')
            //const Tus = require('@uppy/tus')
            
            const rest = api.setter('master/siswa/upload-ujian');
            const uppy = Uppy({
              debug: false,
              autoProceed: false,
              restrictions: {
                maxFileSize: 100000000,
                maxNumberOfFiles: 1,
                minNumberOfFiles: 1,
                allowedFileTypes: ['.csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel']
                //allowedFileTypes: ['image/*', 'video/*']
              }
            })
            .use(Dashboard, {
              trigger: '.UppyModalOpenerBtn',
              inline: true,
              target: '.DashboardContainer',
              replaceTargetContent: true,
              showProgressDetails: true,
              note: 'Excel only, 1 file, up to 100 MB',
              height: 350,
              width:'100%',
              metaFields: [
                { id: 'name', name: 'Name', placeholder: 'file name' },
                { id: 'caption', name: 'Caption', placeholder: 'describe what the file is about' }
              ],
              browserBackButtonClose: true
            })
            //.use(GoogleDrive, { target: Dashboard, serverUrl: 'https://companion.uppy.io' })
            //.use(Dropbox, { target: Dashboard, serverUrl: 'https://companion.uppy.io' })
            //.use(Instagram, { target: Dashboard, serverUrl: 'https://companion.uppy.io' })
            //.use(Webcam, { target: Dashboard })
            //.use(Tus, { endpoint: 'https://master.tus.io/files/' })
            .use(XHRUpload, {
              endpoint: rest.endpoint,
              headers: rest.headers,
              formData: true,
              fieldName: 'file',  
            })
            uppy.on('complete', (result) => {
              if(result.successful && result.successful.length > 0){
                this.init(this.complex.pagination.currentPage, this.toggle_gender, this.filter.tingkat, this.filter.jurusan);        
              }        
            });      
          }catch(e){}
        },
    }
}
</script>
<style>
.v-radio label{font-size:13px}  
.tabular table.v-table tbody td:first-child, .tabular table.v-table tbody td:not(:first-child), .tabular table.v-table tfoot td:first-child, .tabular table.v-table tfoot td:not(:first-child), .tabular table.v-table tbody th:first-child, .tabular table.v-table tbody th:not(:first-child), .tabular table.v-table thead td:first-child, .tabular table.v-table thead td:not(:first-child), .tabular table.v-table thead th:first-child, .tabular table.v-table thead th:not(:first-child) {
    padding: 0 4px;
}
.tabular table.v-table tbody td:first-child, .tabular table.v-table thead th:first-child{
    padding: 0 5px 0 9px
}
.tb-normal{    
  border-collapse: collapse;
}
.tb-normal td, .tb-normal th {
  border: 1px solid #ddd;
  padding: 4px 6px;
}
.optionGroup {
    font-weight: bold;
    font-style: italic;
}
    
.optionChild {
    padding-left: 15px;
}
</style>